import React from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import logo from '../assets/pastovu_logotipas_RGB_color.png';


class Header extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <div>
        <Navbar color="light" light expand="md">
          <NavbarBrand href="/" className="mr-auto">
            <img src={logo} alt="Pastovu projektas" width="15%" height="15%"/>
            <span className="word-wrap">Lietuvių kalbos pastovieji žodžių junginiai</span>
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle}/>
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto align-items-center" navbar>
              <NavItem>
                <NavLink href="/mokomoji-priemone/apie">Mokomoji priemonė</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/paieska/paprastoji">Paieška duomenų bazėje</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/atpazintuvas">Atpažintuvas</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/atsisiusti">Resursai</NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

export default Header;
